import codes from "../../errorCodes/CompanyValues";
export default function companyValuesErrorHandler(code) {
    switch (code) {
        case codes.ErrUnauthorized:
            return "errors.PBCPVUnauthorized";
        case codes.ErrNotFound:
            return "errors.PBCPVNotFound";
        case codes.ErrInvalidArguments:
            return "errors.PBCPVInvalidArguments";
        case codes.ErrAlreadyExists:
            return "errors.PBCPVAlreadyExists";
        case codes.ErrDBPing:
            return "errors.PBCPVDBPing";
        case codes.ErrUnknown:
        default:
            return "";
    }
}
